// extracted by mini-css-extract-plugin
export default {"root":"SignUpFormInfo_root__uU8im","item":"SignUpFormInfo_item__vgaVf","label":"SignUpFormInfo_label__LRx2z","value":"SignUpFormInfo_value__A+1um"};